import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderDrag,
  SliderProgress,
  SliderItem,
  SliderDots,
} from '@studiometa/ui';

/**
 * Slider
 */
export default class HeroSlider extends withBreakpointObserver(SliderCore) {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Slider',
    components: {
      SliderDrag,
      SliderItem,
      SliderProgress,
      SliderDots,
    },
  };

  /**
   * Mounted
   */
  mounted() {
    super.mounted();
    this.timer();
  }

  /**
   * Set an interval to change slide
   */
  timer() {
    this.interval = setInterval(() => {
      if (this.currentIndex < this.indexMax) {
        this.goNext();
      } else {
        this.goTo(0);
      }
    }, 8000);
  }

  /**
   * On dots click reset interval
   */
  onSliderDotsClick() {
    clearInterval(this.interval);
    this.timer();
  }
}
